class StencilTestimonialSlider {
  constructor(el) {
    this.el = el;
    this.slides = Array.from(el.querySelectorAll('.testimonial-card__slide'));
    this.prevBtn = el.querySelector('.testimonial-card__arrow--prev');
    this.nextBtn = el.querySelector('.testimonial-card__arrow--next');
    this.current = 0;

    if (this.slides.length <= 1) return;

    this.prevBtn && this.prevBtn.addEventListener('click', () => this.go(this.current - 1));
    this.nextBtn && this.nextBtn.addEventListener('click', () => this.go(this.current + 1));
  }

  go(index) {
    const total = this.slides.length;
    this.current = (index + total) % total;
    this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.current));
  }
}

document.querySelectorAll('.stencil-testimonial').forEach((el) => new StencilTestimonialSlider(el));

if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const el = event.target.querySelector('.stencil-testimonial');
    if (el) new StencilTestimonialSlider(el);
  });
}